import { useEffect } from "react";

import useMerchant from "./useMerchant";
import { useStorage } from "@/common/hooks/storage.hooks";
import MissingPaymentInfoModal, {
  MISSING_PAYMENT_INFO_STORAGE_KEY,
} from "@/components/Homepage/MissingPaymentInfoModal";
import { showModal } from "@whoppah/ui/Modal2";

const useShowMissingPaymentInfoModal = () => {
  const { load } = useStorage("session");
  const { isPaymentInfoMissing, hasAds } = useMerchant();

  useEffect(() => {
    const alreadyDismissed = load<boolean>(MISSING_PAYMENT_INFO_STORAGE_KEY);

    /** If the user has ads and the payment info is missing, show the modal. */
    if (hasAds && isPaymentInfoMissing && !alreadyDismissed) {
      showModal(MissingPaymentInfoModal);
    }
  }, [hasAds, isPaymentInfoMissing, load]);
};

export default useShowMissingPaymentInfoModal;
